module.exports = __webpack_public_path__ + "static/paris-016.thumb-bd856e1a113ff419018660c212b53333.jpg";